import { createStyles, makeStyles, Theme, withStyles } from '@material-ui/core/styles';
import ProductImageDecorated from '@sprinx/react-com/ProductImageDecorated';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import clsx from 'clsx';
import React from 'react';
import { CatalogueProduct } from '../../../api/products/catalogue';
import useProductAdornmentsMapper from '../../../api/products/useProductAdornmentsMapper';
import ProductDetailLink from '../../../components/ProductDetailLink';
import ProductDiscountPercentElement from '../../../components/ProductDiscountPercentElement';
import useProductUrl from '../../../hooks/useProductUrl';

export interface CataloguePageListContentItemCardImageProps
  extends StandardDivProps<CataloguePageListContentItemCardImageClassKey> {
  product: CatalogueProduct;
}

export type CataloguePageListContentItemCardImageClassKey = 'root' | 'image' | 'middle';

const themeSettings = { name: 'CataloguePageListContentItemCardImage' };
const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles<CataloguePageListContentItemCardImageClassKey, {}>({
      root: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
      },
      middle: {
        [theme.breakpoints.down('sm')]: {
          flexGrow: 0,
        },
      },
      image: {
        '& > div': {
          [theme.breakpoints.down('xl')]: {
            width: theme.spacing(16),
            height: theme.spacing(16),
            marginBottom: theme.spacing(1),
          },
        },
        '& img': {
          [theme.breakpoints.down('xl')]: {
            width: theme.spacing(16),
            height: theme.spacing(16),
          },
        },
      },
    }),
  themeSettings,
);

const CataloguePageListContentItemCardImage = React.forwardRef<
  HTMLDivElement,
  CataloguePageListContentItemCardImageProps
>(({ className, classes: pClasses, product, ...rest }, ref) => {
  const classes = useStyles({ classes: pClasses });
  const imageAdornments = useProductAdornmentsMapper('row', product.adornments, product);
  // const currency = useRecoilValue(currencyState);
  const to = useProductUrl(product);

  return (
    <div ref={ref} className={clsx(classes.root, className)} {...rest}>
      <ProductDetailLink to={to}>
        <ProductImageDecorated
          {...imageAdornments}
          src={product.image as any}
          size='big'
          type='image'
          classes={{ root: classes.image, middle: classes.middle }}
        />
        {/* <AbsoluteDiscount value={product.discountAbsolute} currency={currency} /> */}
        <PercentDiscount value={product.discountPercent} />
      </ProductDetailLink>
    </div>
  );
});

CataloguePageListContentItemCardImage.displayName = 'CataloguePageListContentItemCardImage';

export default withThemeProps(themeSettings)(CataloguePageListContentItemCardImage);

const elementStyles = (absolute?: boolean) => (theme: Theme) => ({
  root: {
    ...theme.typography.body2,
    fontWeight: theme.typography.fontWeightRegular,
    color: theme.palette.primary.main,
    ...(absolute ? { textDecoration: 'line-through' } : {}),
  },
});
// const AbsoluteDiscount = withStyles(elementStyles(true))(ProductDiscountAbsoluteElement);
const PercentDiscount = withStyles(elementStyles(false))(
  ProductDiscountPercentElement,
) as typeof ProductDiscountPercentElement;
